import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemJSON } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import { downloadCheckFile, getExpensesCheckList } from '../../redux/actions/accountingExpenses'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'
import CheckProjectQualityTable from './CheckProjectQualityTable'
import CheckProjectQualityHistoryList from './CheckProjectQualityHistoryList'
import { getQualityCheckList, getQualityCheckListHist, saveQualityCheckList } from '../../redux/actions/subprojectQualityCheckList'

export default function CheckProjectQualityWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  console.log('formSchema==>', formSchema)
  const history = useHistory()

  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})
  const [isCheckHistory, setIsCheckHistory] = useState(false)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isExpanded, setIsExpanded] = useState(true)
  const [addComment, setAddComment] = useState(false)
  const [modalSubProjectCode, setModalSubProjectCode] = useState()

  const [displayLengthHist, setDisplayLengthHist] = useState(5)
  const [pageHist, setPageHist] = useState(1)
  const [historyData, setHistoryData] = useState()
  const [subProjectCode, setSubProjectCode] = useState()

  const onReload = (pageNumber, pageSize) => {
    handleSearch(pageSize, pageNumber, searchRequest)
  }

  const onReloadHist = (pageNumber, pageSize) => {
    handleSearchHistory(pageSize, pageNumber, subProjectCode)
  }

  const handleSearch = async (pageSize, pageNumber, request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getQualityCheckList(request?.projectCode, request?.subProjectCode, pageSize, pageNumber)
      //console.log('resssss 99999 ', response)
      if(response){
        setPage(pageNumber)
        setDisplayLength(pageSize)
        setSearchRequest(request)
        setFormSchema(response)
      }
     
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSearchHistory = async (pageSize, pageNumber, subProjectCode) => {
    console.log('pageSize', pageSize)
    console.log('pageNumber', pageNumber)
    setIsLoading(true)
    startLoading()
    try {
      const response = await getQualityCheckListHist(subProjectCode, pageSize, pageNumber)
      //console.log('resssss 99999 ', response)
      if(response){
        setPageHist(pageNumber)
        setDisplayLengthHist(pageSize)
        setSubProjectCode(subProjectCode)
        setHistoryData(response.form)
      }
     
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)


    try {
      let response = await saveQualityCheckList(request)
      if (response) {
        // setValue(formSchema?.form?.formInput?.notesInput?.name, '')
        // setComment()
        // setCommentLength(0)
        setAddComment(false)
        onReload(page, displayLength)
        //setFormSchema(response)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      projectCode: modalSubProjectCode,
      projectLevel: data.projectQualityLevel,
      mentorLevel: data.nannyQualityLevel,
      comment: data.projectComments
    }

    console.log('request', request)
    handleCallService(request)
  }

  const handleSelect = (rowData) => {
    setIsCheckHistory(true)
    setIsExpanded(false)
    console.log('rowData', rowData)

    handleSearchHistory(displayLengthHist, 1, rowData.subProjectCode)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        <CheckProjectQualityTable
          schema={formSchema?.form}
          Controller={Controller}
          // register={register}
          // control={control}
          // handleSubmit={()=> handleSubmit(onSubmit)}
          // errors={errors}
          // getValues={getValues}
          // setValue={setValue}
          // setError={setError}
          // clearErrors={clearErrors}
          addComment={addComment}
          setAddComment={setAddComment}
          setModalSubProjectCode={setModalSubProjectCode}
          pagination={true}
          loading={isLoading}
          onSelect={handleSelect}
          onReload={onReload}
          handleOnSubmit={onSubmit}
          onSearch={(pageSize, pageNumber, req) => {
            handleSearch(pageSize, pageNumber, req)
          }}
          onCancel={(pageSize, pageNumber) => {
            handleSearch(pageSize, pageNumber)
          }}
          page={page}
          displayLength={displayLength}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
      <br />
      {(isCheckHistory || selectRowData) && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={'ประวัติการตรวจสอบคุณภาพ'}
          bordered
          expanded={isExpandedForm}
          onSelect={() => {
            setIsExpandedForm(!isExpandedForm)
          }}
        >
          <CheckProjectQualityHistoryList
            schema={historyData}
            Controller={Controller}
            control={control}
            pagination={true}
            loading={isLoading}
            //onSelect={handleSelect}
            onReload={onReloadHist}
            onSearch={(pageSize, pageNumber, req) => {
              handleSearchHistory(pageSize, pageNumber, req)
            }}
            onCancel={(pageSize, pageNumber) => {
              handleSearchHistory(pageSize, pageNumber)
            }}
            page={pageHist}
            displayLength={displayLengthHist}
          />
        </Panel>
      )}
    </>
  )
}
